import Collapse from 'bootstrap/js/dist/collapse';
import Tooltip from 'bootstrap/js/dist/tooltip';
import Dropdown from 'bootstrap/js/dist/dropdown';
globalThis.unlk = globalThis.unlk || {};

Object.assign(globalThis.unlk, {
  Collapse,
  Dropdown,
  Tooltip
});

import { maybeResetEduCookies } from './utilities/_get-progress';
import { maybeRedirectStaleFaqAnchor } from './utilities/_faq-anchor-redirect';

// eslint-disable-next-line no-unused-vars
let wpAdminBar = 0;
let headerHeight;
let headerMarginTop;
let collapseBound = false;
const headerEl = document.querySelector('header');
const isMobile = () => globalThis.matchMedia('(max-width: 991.98px)').matches;

maybeResetEduCookies();
maybeRedirectStaleFaqAnchor();
document.addEventListener('DOMContentLoaded', init);
globalThis.addEventListener('resize', resize);

function init() {
  if (!headerEl) return;

  headerHeight = headerEl.offsetHeight;
  headerMarginTop = getComputedStyle(headerEl).marginTop || '0px';

  // scroll padding/margin for anchored headers
  document.documentElement.style.scrollPaddingTop = `calc(${headerHeight}px + ${headerMarginTop} + 40px)`;
  document.documentElement.style.scrollMarginTop = `calc(${headerHeight}px + ${headerMarginTop} + 40px)`;

  const windowHeight = window.innerHeight;

  // Bootstrap tooltips
  const tooltipTriggerEls = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  for (const el of tooltipTriggerEls) {
    // eslint-disable-next-line no-new
    new Tooltip(el);
  }

  // Move modals to body
  for (const modal of document.querySelectorAll('.modal')) {
    document.body.append(modal);
  }

  // Mobile max-height for mega menu
  if (isMobile()) {
    const menuContainer = document.querySelector(
      '#mega-menu-wrap-primary .mega-menu-toggle + #mega-menu-primary'
    );
    if (menuContainer) {
      menuContainer.style.maxHeight = `calc(${windowHeight}px - ${headerHeight}px)`;
    }
  }

  // Admin bar sizing / placement
  if (document.querySelector('#wpadminbar')) {
    adminSize();
  }

  anchorScroll();
  openFaqFromHash();
  globalThis.addEventListener('hashchange', openFaqFromHash);
  stickyNav();
  bsCollapse();
  mobileBottomNav();
}

function resize() {
  if (!headerEl) return;

  headerHeight = headerEl.offsetHeight;

  const windowHeight = window.innerHeight;

  if (isMobile()) {
    const menuContainer = document.querySelector(
      '#mega-menu-wrap-primary .mega-menu-toggle + #mega-menu-primary'
    );
    if (menuContainer) {
      menuContainer.style.maxHeight = `calc(${windowHeight}px - ${headerHeight}px)`;
    }
  }

  if (document.querySelector('#wpadminbar')) {
    adminSize();
  }

  stickyNav();
}

function bsCollapse() {
  if (collapseBound) return;
  collapseBound = true;

  document.addEventListener('show.bs.collapse', (e) => {
    if (e.target.dataset.collapse !== 'blur') return;
    document.body.classList.add('blur');
  });

  document.addEventListener('hidden.bs.collapse', (e) => {
    if (e.target.dataset.collapse !== 'blur') return;

    if (!document.querySelector('.collapse.show[data-collapse="blur"]')) {
      document.body.classList.remove('blur');
    }
  });
}

function adminSize() {
  const adminBar = document.querySelector('#wpadminbar');
  const wrapperNavbar = document.querySelector('#wrapper-navbar');

  if (adminBar && wrapperNavbar) {
    wrapperNavbar.prepend(adminBar);
  }

  wpAdminBar = globalThis.matchMedia('(max-width: 782.98px)').matches ? 46 : 32;
}

function stickyNav() {
  if (!document.querySelector('.myObserver')) {
    const newEl = document.createElement('div');
    newEl.classList.add('myObserver');
    const ref = document.querySelector('header');
    if (ref && ref.parentNode) {
      ref.parentNode.insertBefore(newEl, ref);
    }
  }

  const observerTarget = document.querySelector('.myObserver');
  if (!observerTarget) return;

  const observer = new IntersectionObserver(
    (entries) => {
      const entry = entries[0];
      const mainNav = document.querySelector('#main-nav');
      const preNav = document.querySelector('#pre-nav');

      if (!mainNav) return;
      // if (!globalThis.matchMedia('(min-width: 992px)').matches) return;

      if (entry.intersectionRatio === 0) {
        mainNav.classList.add('shrink-nav');

        const headerNode = document.querySelector('header');
        if (headerNode) {
          const onTransitionEnd = () => {
            headerHeight = headerNode.offsetHeight;
            const noticeMenu = document.querySelector('.otnotice-menu');

            if (noticeMenu) {
              noticeMenu.style.top = `calc(${headerHeight}px + 10px)`;
            }

            document.documentElement.style.scrollPaddingTop = `calc(${headerHeight}px + 10px)`;
            headerNode.removeEventListener('transitionend', onTransitionEnd);
          };

          headerNode.addEventListener('transitionend', onTransitionEnd);
        }
      } else if (entry.intersectionRatio === 1) {
        if (mainNav) mainNav.classList.remove('shrink-nav');
        if (preNav) preNav.classList.remove('shrink-nav');
      }
    },
    { threshold: [0, 1] }
  );

  observer.observe(observerTarget);
}

function applyStickyHeader() {
  if (!headerEl) return;
  const isVisible = window.scrollY > 0;
  headerEl.classList.toggle('sticky-top', isVisible);
  headerEl.classList.toggle('position-relative', !isVisible);
}

function mobileBottomNav() {
  const bottomNav = document.querySelector('.navbar-mobile-bottom');
  if (!bottomNav) return;

  let ticking = false;
  let settleTimeout;
  let wasVisible = false;
  let keyboardOpen = false;

  const update = () => {
    ticking = false;
    const isScrolled = window.scrollY > 0;
    const isVisible = isScrolled && !keyboardOpen;
    bottomNav.classList.toggle('d-none', !isVisible);
    bottomNav.classList.toggle('d-flex', isVisible);

    if (isVisible) {
      document.body.style.paddingBottom = `${bottomNav.offsetHeight}px`;
    }

    if (!isScrolled && headerEl) {
      clearTimeout(settleTimeout);
      applyStickyHeader();
    } else if (isScrolled && !wasVisible) {
      clearTimeout(settleTimeout);
      settleTimeout = setTimeout(applyStickyHeader, 500);
    }

    wasVisible = isScrolled;
  };

  globalThis.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }, { passive: true });

  globalThis.addEventListener('focusin', (e) => {
    if (!e.target.matches('input, textarea, select')) return;
    keyboardOpen = true;
    update();
  });

  globalThis.addEventListener('focusout', (e) => {
    if (!e.target.matches('input, textarea, select')) return;
    keyboardOpen = false;
    update();
  });

  update();
}

function anchorScroll() {
  const anchorSelector = 'a[href^="#"]';
  const anchorList = document.querySelectorAll(anchorSelector);

  for (const link of anchorList) {
    link.addEventListener('click', function (e) {
      const { hash } = this;
      if (!hash) return;

      const destination = document.querySelector(hash);
      if (!destination) return;

      e.preventDefault();
      setScrollPaddingForHeader();

      if (openFaqForElement(destination)) return;

      destination.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
}

function setScrollPaddingForHeader() {
  const headerNode = document.querySelector('header');
  if (headerNode) {
    const h = headerNode.offsetHeight || 0;
    document.documentElement.style.scrollPaddingTop = `calc(${h}px + 40px)`;
    document.documentElement.style.scrollMarginTop = `calc(${h}px + 40px)`;
  }
}

function openFaqFromHash() {
  const { hash } = globalThis.location;
  if (!hash) return;

  setTimeout(() => {
    const target = document.querySelector(hash);
    if (!target) return;

    setScrollPaddingForHeader();

    if (openFaqForElement(target)) return;

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, 50);
}

function openFaqForElement(el) {
  let item = el.closest?.('.accordion-item') || null;
  let collapseEl = el.classList?.contains('accordion-collapse') ? el : null;

  const headerBtn = el.matches?.('[data-bs-toggle="collapse"]')
    ? el
    : el.querySelector?.('[data-bs-toggle="collapse"]');

  if (!collapseEl && headerBtn) {
    const sel = headerBtn.getAttribute('data-bs-target') || headerBtn.getAttribute('data-target');
    if (sel) collapseEl = document.querySelector(sel);
    if (!item) item = headerBtn.closest('.accordion-item');
  }

  if (!collapseEl && item) {
    collapseEl = item.querySelector('.accordion-collapse');
  }

  if (!collapseEl) return false;

  const instance = Collapse.getOrCreateInstance(collapseEl);
  instance.show();

  const scrollTarget = item || el;
  setTimeout(() => {
    scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, 250);

  return true;
}
